import PropTypes from 'prop-types'
import { kea } from 'kea'
import { take, put, fork, race } from 'redux-saga/effects'

import { updateHeaderFavouritesCount } from 'lib/actions/props'

import controller from '~/scenes/search/controller.rb'

import sceneLogic from '~/scenes/search/logic'

export default kea({
  connect: {
    actions: [sceneLogic, ['receiveFavourites']]
  },

  actions: () => ({
    setFavourite: course => ({ course }),
    removeFavourite: course => ({ course }),
    resetSettingFavourite: true
  }),

  reducers: ({ actions }) => ({
    settingFavourite: [
      null,
      PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
      {
        [actions.setFavourite]: (_, payload) => payload.course.id,
        [actions.removeFavourite]: (_, payload) => payload.course.id,
        [actions.resetSettingFavourite]: () => null
      }
    ]
  }),

  * start () {
    if (typeof window === 'undefined') {
      return
    }

    yield fork(this.workers.favouriteWorker)
  },

  workers: {
    * favouriteWorker () {
      const { setFavourite, removeFavourite, receiveFavourites, resetSettingFavourite } = this.actions

      while (true) {
        const { add, remove } = yield race({
          add: take(setFavourite),
          remove: take(removeFavourite)
        })

        let response

        if (add) {
          response = yield controller.addFavourite({ course_id: add.payload.course.id })
        } else if (remove) {
          response = yield controller.removeFavourite({ course_id: remove.payload.course.id })
        }

        if (response.redirect_to_signup) {
          window.location.href = response.redirect_path
        }

        const favourites = response.favourites || []

        if (typeof window !== 'undefined' && window.fbq && add && favourites && favourites.length > 0) {
          window.fbq('track', 'AddToWishlist')
        }

        yield put(receiveFavourites(favourites))
        yield put(updateHeaderFavouritesCount(favourites.length))
        yield put(resetSettingFavourite())
      }
    }
  }
})
